import { createFileRoute } from "@tanstack/react-router";
import NotaryFaqHubIntl from "@/components/NotaryFaqHubIntl";
import { NOTARY_FAQ_JA } from "@/data/notary-faq-intl";
import { SEO_SITE, ctaDesc, ctaTitle } from "@/lib/seo";

const C = NOTARY_FAQ_JA;
const URL = `${SEO_SITE}/ja/notary/faq`;

export const Route = createFileRoute("/ja/notary/faq")({
  head: () => ({
    meta: [
      { title: ctaTitle(C.title, "/ja/notary/faq", "th")},
      { name: "description", content: ctaDesc(C.metaDesc, "/ja/notary/faq", "th")},
      { property: "og:title", content: ctaTitle(C.title, "/ja/notary/faq", "th")},
      { property: "og:description", content: ctaDesc(C.metaDesc, "/ja/notary/faq", "th")},
      { property: "og:url", content: URL },
      { property: "og:locale", content: C.ogLocale },
      { property: "og:type", content: "website" },
    ],
    links: [
      { rel: "canonical", href: URL },
      { rel: "alternate", hrefLang: "ja", href: URL },
      { rel: "alternate", hrefLang: "zh", href: `${SEO_SITE}/zh/notary/faq` },
      { rel: "alternate", hrefLang: "ko", href: `${SEO_SITE}/ko/notary/faq` },
      { rel: "alternate", hrefLang: "th", href: `${SEO_SITE}/notary/faq` },
      { rel: "alternate", hrefLang: "en", href: `${SEO_SITE}/en/notary/faq` },
      { rel: "alternate", hrefLang: "x-default", href: `${SEO_SITE}/notary/faq` },
    ],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "FAQPage", inLanguage: C.langAttr,
        mainEntity: C.faqs.map((f) => ({
          "@type": "Question", name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a.replace(/&lt;/g, "<") },
        })),
      }) },
      { type: "application/ld+json", children: JSON.stringify({
        "@context": "https://schema.org", "@type": "QAPage", inLanguage: C.langAttr,
        name: C.title,
        speakable: { "@type": "SpeakableSpecification", cssSelector: [".voice-faq-q", ".voice-faq-a"] },
      }) },
    ],
  }),
  component: () => <NotaryFaqHubIntl c={C} />,
});
